module.exports = __webpack_public_path__ + "static/media/jungle.678bb7a9.mp3";